// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider___3TkTO"};